/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardProviderTier } from './RewardProviderTier';
import {
    RewardProviderTierFromJSON,
    RewardProviderTierFromJSONTyped,
    RewardProviderTierToJSON,
    RewardProviderTierToJSONTyped,
} from './RewardProviderTier';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { DurationUnit } from './DurationUnit';
import {
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    DurationUnitToJSONTyped,
} from './DurationUnit';
import type { AmountUnit } from './AmountUnit';
import {
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    AmountUnitToJSONTyped,
} from './AmountUnit';
import type { EmailTemplate } from './EmailTemplate';
import {
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    EmailTemplateToJSONTyped,
} from './EmailTemplate';

/**
 * 
 * @export
 * @interface CreateRewardConfigRequestBody
 */
export interface CreateRewardConfigRequestBody {
    /**
     * 
     * @type {RewardType}
     * @memberof CreateRewardConfigRequestBody
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldEmailUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldEmailAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldSendNotificationWeb: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldSendNotificationDevourPlay: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    amount?: number;
    /**
     * How many times one member may ever be granted this reward. Omit for no ceiling.
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    maxGrantsPerUser?: number;
    /**
     * How many times one member may be granted this reward within a single board period. Omit for no per-period cap.
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    maxGrantsPerPeriod?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof CreateRewardConfigRequestBody
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof CreateRewardConfigRequestBody
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    questConfigId?: string;
    /**
     * LootBoxConfig ID granted for LOOTBOX reward type
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    lootBoxConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof CreateRewardConfigRequestBody
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    claimFormUrl?: string;
    /**
     * When true, consumers render the platform inline RewardFulfillmentClaimForm instead of opening claimFormUrl. Use for physical-ship MERCH and manually-fulfilled GIFT_CARD rewards.
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    useInlineFulfillmentForm?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    disclaimer?: string;
    /**
     * Tillo brand slug for gift card issuance (set via brand picker)
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    tilloProductId?: string;
    /**
     * Human-readable brand name (auto-populated from picker)
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    tilloBrandName?: string;
    /**
     * Gift card face value in USD
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    giftCardAmount?: number;
    /**
     * 
     * @type {RewardProviderTier}
     * @memberof CreateRewardConfigRequestBody
     */
    providerTier?: RewardProviderTier;
    /**
     * The owning brand for PARTNER-tier rewards.
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    ownerBrandId?: string;
    /**
     * Curation opt-in for self-serve pickers.
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    selfServeVisible?: boolean;
}



/**
 * Check if a given object implements the CreateRewardConfigRequestBody interface.
 */
export function instanceOfCreateRewardConfigRequestBody(value: object): value is CreateRewardConfigRequestBody {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('shouldEmailUser' in value) || value['shouldEmailUser'] === undefined) return false;
    if (!('shouldEmailAdmin' in value) || value['shouldEmailAdmin'] === undefined) return false;
    if (!('shouldSendNotificationWeb' in value) || value['shouldSendNotificationWeb'] === undefined) return false;
    if (!('shouldSendNotificationDevourPlay' in value) || value['shouldSendNotificationDevourPlay'] === undefined) return false;
    return true;
}

export function CreateRewardConfigRequestBodyFromJSON(json: any): CreateRewardConfigRequestBody {
    return CreateRewardConfigRequestBodyFromJSONTyped(json, false);
}

export function CreateRewardConfigRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRewardConfigRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'],
        'shouldEmailUser': json['shouldEmailUser'],
        'shouldEmailAdmin': json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': json['shouldSendNotificationDevourPlay'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'maxGrantsPerUser': json['maxGrantsPerUser'] == null ? undefined : json['maxGrantsPerUser'],
        'maxGrantsPerPeriod': json['maxGrantsPerPeriod'] == null ? undefined : json['maxGrantsPerPeriod'],
        'amountUnit': json['amountUnit'] == null ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': json['durationAmount'] == null ? undefined : json['durationAmount'],
        'durationUnit': json['durationUnit'] == null ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'nftTrackerId': json['nftTrackerId'] == null ? undefined : json['nftTrackerId'],
        'orderDiscountId': json['orderDiscountId'] == null ? undefined : json['orderDiscountId'],
        'promoTokenId': json['promoTokenId'] == null ? undefined : json['promoTokenId'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
        'emailTemplate': json['emailTemplate'] == null ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': json['claimFormUrl'] == null ? undefined : json['claimFormUrl'],
        'useInlineFulfillmentForm': json['useInlineFulfillmentForm'] == null ? undefined : json['useInlineFulfillmentForm'],
        'maxClaimCount': json['maxClaimCount'] == null ? undefined : json['maxClaimCount'],
        'disclaimer': json['disclaimer'] == null ? undefined : json['disclaimer'],
        'tilloProductId': json['tilloProductId'] == null ? undefined : json['tilloProductId'],
        'tilloBrandName': json['tilloBrandName'] == null ? undefined : json['tilloBrandName'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'providerTier': json['providerTier'] == null ? undefined : RewardProviderTierFromJSON(json['providerTier']),
        'ownerBrandId': json['ownerBrandId'] == null ? undefined : json['ownerBrandId'],
        'selfServeVisible': json['selfServeVisible'] == null ? undefined : json['selfServeVisible'],
    };
}

export function CreateRewardConfigRequestBodyToJSON(json: any): CreateRewardConfigRequestBody {
    return CreateRewardConfigRequestBodyToJSONTyped(json, false);
}

export function CreateRewardConfigRequestBodyToJSONTyped(value?: CreateRewardConfigRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'shouldEmailUser': value['shouldEmailUser'],
        'shouldEmailAdmin': value['shouldEmailAdmin'],
        'shouldSendNotificationWeb': value['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': value['shouldSendNotificationDevourPlay'],
        'amount': value['amount'],
        'maxGrantsPerUser': value['maxGrantsPerUser'],
        'maxGrantsPerPeriod': value['maxGrantsPerPeriod'],
        'amountUnit': AmountUnitToJSON(value['amountUnit']),
        'durationAmount': value['durationAmount'],
        'durationUnit': DurationUnitToJSON(value['durationUnit']),
        'assetId': value['assetId'],
        'nftTrackerId': value['nftTrackerId'],
        'orderDiscountId': value['orderDiscountId'],
        'promoTokenId': value['promoTokenId'],
        'questConfigId': value['questConfigId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
        'emailTemplate': EmailTemplateToJSON(value['emailTemplate']),
        'claimFormUrl': value['claimFormUrl'],
        'useInlineFulfillmentForm': value['useInlineFulfillmentForm'],
        'maxClaimCount': value['maxClaimCount'],
        'disclaimer': value['disclaimer'],
        'tilloProductId': value['tilloProductId'],
        'tilloBrandName': value['tilloBrandName'],
        'giftCardAmount': value['giftCardAmount'],
        'providerTier': RewardProviderTierToJSON(value['providerTier']),
        'ownerBrandId': value['ownerBrandId'],
        'selfServeVisible': value['selfServeVisible'],
    };
}

